import { createContext, useRef } from "react";

export const AppContext = createContext();

const AppContextProvider = ({ children }) => {
  // Refs
  const audioRef = useRef(null);

  // Utils
  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  return (
    <AppContext.Provider value={{ playAudio, audioRef }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
